import React from 'react';
import {
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CancelIcon from '@mui/icons-material/Cancel';

export default function TableFilter({ value, setValue, data, filterName }) {
  const handleRemoveItem = (idx) => {
    const newValue = [...value];
    newValue.splice(idx, 1);
    setValue(newValue);
  };

  return (
    <FormControl
      variant="outlined"
      sx={{ minWidth: 150, marginRight: 1 }}
      size="small"
    >
      <InputLabel id={`${filterName}-label`}>{filterName}</InputLabel>
      <Select
        labelId={`${filterName}-label`}
        id={`${filterName}-select`}
        multiple
        label={filterName}
        value={value}
        onChange={(e) => {
          const val = e.target.value;
          setValue(Array.isArray(val) ? val : [val]);
        }}
        IconComponent={KeyboardArrowDownIcon}
        renderValue={(selected) => {
          if (!selected || selected.length === 0) {
            return <em>None</em>;
          }

          const firstItem = data.find((d) => d.value === selected[0]);
          const firstLabel = firstItem ? firstItem.label : selected[0];

          if (selected.length === 1) {
            return (
              <Chip
                label={firstLabel}
                onDelete={() => handleRemoveItem(0)}
                deleteIcon={<CancelIcon onMouseDown={(e) => e.stopPropagation()} />}
                size="small"
              />
            );
          }

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Chip
                label={firstLabel}
                onDelete={() => handleRemoveItem(0)}
                deleteIcon={<CancelIcon onMouseDown={(e) => e.stopPropagation()} />}
                size="small"
              />
              <span>{`+${selected.length - 1}`}</span>
            </div>
          );
        }}
      >
        {data.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            <Checkbox checked={value.includes(item.value)} />
            <ListItemText primary={item.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
